import { getConnection } from "./adbConnection";
import { shellCmd } from "./adbShell";

/**
 * Launch an installed app on the connected device using the `monkey` command.
 * This opens the app's default launcher activity without needing to know the exact activity name.
 */
export async function launchApp(packageName: string): Promise<void> {
  const adb = getConnection();
  if (!adb) {
    throw new Error("No ADB connection");
  }

  const output = await shellCmd(adb, [
    "monkey",
    "-p",
    packageName,
    "-c",
    "android.intent.category.LAUNCHER",
    "1",
  ]);

  // monkey returns "Events injected: 1" on success
  if (!output.includes("Events injected: 1")) {
    throw new Error(output.trim() || "Failed to launch application");
  }
}
